<template>
  <div class="legal-contenedor">
    <div class="legal-card">
      <img class="logo" src="@/assets/imagenes/logotipo.png" alt="Domédica" />
      <h1 class="titulo">Términos y Condiciones del Servicio</h1>
      <div class="legal-texto">
        <h2>1. Identificación del prestador del servicio</h2>
        <p>Domédica es un servicio de coordinación y prestación de consultas médicas a domicilio, brindadas por médicos legalmente facultados para ejercer la profesión en territorio nacional, conforme a la legislación aplicable. La solicitud y utilización de los servicios implica la aceptación plena de los presentes Términos y Condiciones.</p>

        <h2>2. Objeto del servicio</h2>
        <p>Domédica proporciona servicios de atención médica general a domicilio previamente solicitados por el paciente, hotel, empresa o persona autorizada. Los servicios pueden incluir, de manera enunciativa más no limitativa:</p>
        <ul>
          <li>Consulta médica general a domicilio.</li>
          <li>Valoración clínica.</li>
          <li>Emisión de receta médica cuando proceda.</li>
          <li>Orientación general de salud.</li>
          <li>Servicios complementarios que se encuentren vigentes en el catálogo oficial de Domédica.</li>
        </ul>

        <h2>3. Cobertura y disponibilidad</h2>
        <p>Los servicios se prestarán dentro de las zonas de cobertura definidas por Domédica y estarán sujetos a la disponibilidad operativa y profesional del personal médico. Los tiempos estimados de llegada son aproximados y podrán variar por condiciones de tránsito, clima, distancia, disponibilidad médica u otras circunstancias ajenas al control de Domédica.</p>

        <h2>4. Naturaleza del servicio</h2>
        <p>Los servicios prestados por Domédica corresponden exclusivamente a consultas médicas programadas o solicitadas para atención inmediata, conforme a la disponibilidad del servicio. Domédica no tiene contemplado la prestación de servicios de ambulancia, atención prehospitalaria especializada, traslado de pacientes ni atención de emergencias médicas. En caso de que el médico tratante determine que la condición del paciente requiere atención hospitalaria, especializada o de urgencia, podrá recomendar o apoyar en la gestión de la referencia correspondiente.</p>

        <h2>5. Solicitud del servicio</h2>
        <p>La solicitud podrá realizarse mediante WhatsApp, llamada telefónica, código QR, hotel, empresa afiliada o cualquier otro medio previamente autorizado por Domédica. El solicitante declara que la información proporcionada es veraz y suficiente para coordinar la atención médica.</p>

        <h2>6. Honorarios y formas de pago</h2>
        <p>Las tarifas vigentes serán las publicadas o comunicadas por Domédica al momento de solicitar el servicio. El pago podrá realizarse mediante los medios autorizados por Domédica, incluyendo efectivo, transferencia bancaria, terminal bancaria u otros medios electrónicos habilitados. La consulta se considerará concluida una vez realizado el pago correspondiente.</p>

        <h2>7. Facturación</h2>
        <p>La emisión de Comprobantes Fiscales Digitales por Internet (CFDI) estará disponible únicamente para personas físicas o morales que cuenten con Registro Federal de Contribuyentes (RFC) vigente en México. Para solicitar factura, el pago deberá realizarse mediante transferencia bancaria a la cuenta indicada por Domédica y el solicitante deberá proporcionar oportunamente la información fiscal requerida. Los pacientes extranjeros o personas que no cuenten con RFC vigente podrán solicitar únicamente un comprobante de pago no fiscal.</p>

        <h2>8. Servicios adicionales</h2>
        <p>Determinados procedimientos, evaluaciones, informes, materiales o servicios distintos a la consulta médica estándar podrán generar cargos adicionales. La aceptación de cualquier servicio adicional implica la aceptación del cargo correspondiente.</p>

        <h2>9. Responsabilidades del paciente</h2>
        <p>El paciente se compromete a:</p>
        <ul>
          <li>Proporcionar información veraz y completa sobre su estado de salud.</li>
          <li>Informar antecedentes médicos relevantes, alergias y tratamientos en curso.</li>
          <li>Seguir las indicaciones médicas proporcionadas durante la consulta.</li>
          <li>Proporcionar un entorno seguro para la atención médica.</li>
        </ul>
        <p>Domédica no será responsable por consecuencias derivadas de información falsa, incompleta u omitida por el paciente o solicitante.</p>

        <h2>10. Limitación de responsabilidad</h2>
        <p>La atención médica proporcionada por los profesionales de la salud se realiza conforme a los principios científicos, éticos y legales aplicables al ejercicio de la medicina. No obstante, debido a la naturaleza propia de los servicios médicos, Domédica no garantiza resultados específicos derivados de diagnósticos, tratamientos, procedimientos o recomendaciones médicas.</p>

        <h2>11. Propiedad intelectual</h2>
        <p>La marca Domédica, logotipos, materiales informativos, formularios, diseños, contenidos digitales y demás elementos relacionados con el servicio son propiedad de sus titulares y se encuentran protegidos por la legislación aplicable. Queda prohibida su reproducción, modificación o utilización sin autorización previa y por escrito.</p>

        <h2>12. Datos personales</h2>
        <p>El tratamiento de los datos personales del paciente se realizará conforme a lo establecido en el <router-link to="/privacidad">Aviso de Privacidad</router-link> vigente de Domédica, disponible para consulta en el sitio web oficial. Asimismo, durante la consulta médica se informa al paciente sobre dicho Aviso de Privacidad.</p>

        <h2>13. Modificaciones</h2>
        <p>Domédica podrá modificar los presentes Términos y Condiciones en cualquier momento para adaptarlos a cambios operativos, legales o comerciales. Las modificaciones entrarán en vigor a partir de su publicación en los medios oficiales de Domédica.</p>

        <h2>14. Legislación y jurisdicción</h2>
        <p>Los presentes Términos y Condiciones se regirán por las leyes aplicables en los Estados Unidos Mexicanos. Cualquier controversia derivada de la prestación de los servicios será sometida a la jurisdicción de los tribunales competentes del Estado de Oaxaca, renunciando las partes a cualquier otro fuero que pudiera corresponderles por razón de su domicilio presente o futuro.</p>
      </div>
      <button class="btn-volver" @click="$router.back()">
        <span class="material-icons">arrow_back</span>
        Volver
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaginaTerminos',
};
</script>

<style scoped>
.legal-contenedor {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 40px 16px;
  background: var(--brand-beige);
}

.legal-card {
  width: min(820px, 100%);
  background: var(--white);
  border-radius: 18px;
  padding: 36px clamp(20px, 4vw, 44px);
  box-shadow: 0 8px 25px rgba(19, 62, 104, 0.12);
}

.logo {
  display: block;
  width: 140px;
  margin: 0 auto 20px;
}

.titulo {
  color: var(--brand-primary);
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 28px;
}

.legal-texto h2 {
  color: var(--brand-primary);
  font-size: 16px;
  font-weight: 700;
  margin: 22px 0 8px;
}

.legal-texto h2:first-child { margin-top: 0; }

.legal-texto p,
.legal-texto li {
  color: var(--brand-secondary);
  font-size: 14px;
  line-height: 1.6;
}

.legal-texto ul { margin: 8px 0; padding-left: 22px; }

.legal-texto a {
  color: var(--brand-accent-sage);
  font-weight: 600;
}

.btn-volver {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 28px auto 0;
  padding: 12px 24px;
  background: var(--brand-accent-sage);
  color: var(--white);
  border: none;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-volver:hover { background: var(--brand-accent-navy); }
</style>
